import { Drawer, Hidden, List, ListItem, makeStyles } from '@material-ui/core';
import React, { useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import logo from '../assets/logo.png';

const drawerWidth = 400;

const useStyles = makeStyles((theme) => ({
    appBar: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
    },
    drawer: {
        width: drawerWidth,
        transition: 'ease all .5s',
        [theme.breakpoints.down('md')]: {
            width: drawerWidth * 0.5,
        },
    },
    drawerPaper: {
        width: drawerWidth,
        transition: 'ease all .5s',
        [theme.breakpoints.down('md')]: {
            width: drawerWidth * 0.5,
        },
    },
    menu: {
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        textAlign: 'center',
        '& div': {
            width: '100%',
            margin: 'auto',
        },
    },
    logo: {
        textAlign: 'center',
        width: drawerWidth,
        margin: 'auto',
        [theme.breakpoints.down('sm')]: {
            width: drawerWidth * 0.5,
            '& img': {
                display: 'none',
            },
        },
    },
    nav: {
        width: 200,
        margin: 'auto',
        marginTop: 25,
        [theme.breakpoints.down('sm')]: {
            marginTop: 0,
        },
    },
    listLinkText: {
        fontFamily: `Montserrat, sans-serif !important`,
        fontWeight: 400,
    },
}));

const Sidebar = ({ onMobileClose, openMobile }) => {
    const classes = useStyles();
    const location = useLocation();

    useEffect(() => {
        if (openMobile && onMobileClose) {
            onMobileClose();
        }
    }, [location.pathname]);

    const links = [
        { to: '/', label: 'About' },
        { to: '/dungeonland', label: 'Dungeonland' },
        { to: '/midnight-draw', label: 'Midnight Draw' },
        { to: '/hypercasuals', label: 'Hyper Casuals' },
        { to: '/yatzy-party', label: 'Yatzy Party' },
        { to: '/dominos', label: 'Dominos' },
        { to: '/mma-federation', label: 'MMA Federation' },
    ];

    const content = (
        <div className={classes.menu}>
            <div>
                <NavLink to='/' className={classes.logo}>
                    <img src={logo} alt='dm games' />
                </NavLink>
                <List component='nav' className={classes.nav}>
                    {links.map((l, i) => (
                        <ListItem
                            component={NavLink}
                            to={l.to}
                            exact
                            activeStyle={{
                                fontWeight: 800,
                            }}
                            className={classes.listLinkText}
                            button
                            key={`nav-${i}`}
                        >
                            {l.label}
                        </ListItem>
                    ))}
                </List>
            </div>
        </div>
    );

    return (
        <>
            <Hidden mdUp>
                <Drawer
                    anchor='left'
                    classes={{ paper: classes.drawer }}
                    onClose={onMobileClose}
                    open={openMobile}
                    variant='temporary'
                >
                    {content}
                </Drawer>
            </Hidden>

            <Hidden smDown>
                <Drawer
                    anchor='left'
                    variant='permanent'
                    classes={{
                        paper: classes.drawerPaper,
                    }}
                    className={classes.drawer}
                >
                    {content}
                </Drawer>
            </Hidden>
        </>
    );
};

export default Sidebar;
